import { RetrieveConfig } from "interfaces/retrieve";


const defaultConfiguration: RetrieveConfig[string] = {
  hasInstructions: true,
  origins: {
    defaultOrigin: "",
    showCode: false,
    hideCrossLinksMobile: false,
  },
  pools: {
    poolsPerRow: 3,
    maxDestinations: 12,
    hasButton: true,
    hasPoolInstruction: true,
  },
};

const ewgConfig: RetrieveConfig[string] = {
  origins: {
    defaultOrigin: "DUS",
    showCode: true,
  },
  pools: {
    poolsPerRow: 3,
    maxDestinations: 12,
  },
  showEmptyOrigins: true,
};

const configuration: RetrieveConfig = {
  oss: {
    hasInstructions: true,
    origins: {
      defaultOrigin: "VIE",
      showCode: false,
      hideCrossLinksMobile: false,
    },
    pools: {
      poolsPerRow: 3,
      maxDestinations: 21,
      hasButton: true,
      hasPoolInstruction: true, 
    },
  },
  ewg: ewgConfig,
  ald: {
    ...ewgConfig,
    showEmptyOrigins: false,
  },
  default: defaultConfiguration,
};

export default configuration;
